import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { DestinationService } from '../common/services/destination.service';
import { DomainService } from '../common/services/domain.service';
import { SanitizeHTmlPipe } from './pipes/sanitize.pipe';
import { OrderByPipe } from './pipes/order.pipe';
import { InputWithCounterComponent } from './components/input-with-counter/input-with-counter.component';
import { AutocompleteSearchComponent } from 'OpsCenter/shared/components/autocomplete-search/autocomplete-search.component';
import { ClickOutsideDirective } from 'OpsCenter/shared/directives/click-outside.directive';
import { DropdownMenuComponent } from 'OpsCenter/shared/components/dropdown-menu/dropdown-menu.component';
import { HighlightPipe } from 'OpsCenter/shared/pipes/highlight/highlight.pipe';
import { LoaderComponent } from 'OpsCenter/shared/components/loader/loader.component';
import { ButtonComponent } from 'OpsCenter/shared/components/button/button.component';
import { FocusOnDirective } from 'OpsCenter/shared/directives/focus-on/focus-on.directive';
import { ApprovalPopupComponent } from 'OpsCenter/shared/components/approval-popup/approval-popup.component';
import { FileDropDirective } from 'OpsCenter/shared/directives/file-drop/file-drop.directive';
import { DaterangepickerComponent } from 'OpsCenter/shared/components/daterangepicker/daterangepicker.component';
import { CustomDateParserFormatter } from 'OpsCenter/shared/components/daterangepicker/custom-date-parser-formatter';
import { CustomAdapter } from 'OpsCenter/shared/components/daterangepicker/custom-adapter';
import { MultiSelectFilterComponent } from 'OpsCenter/shared/components/multi-select-filter/multi-select-filter.component';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [FormsModule, CommonModule, NgbDatepickerModule, NgbDropdownModule, ToastrModule, TranslateModule],
  providers: [
    DestinationService,
    DomainService,
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  declarations: [
    SanitizeHTmlPipe,
    OrderByPipe,
    InputWithCounterComponent,
    AutocompleteSearchComponent,
    DropdownMenuComponent,
    ClickOutsideDirective,
    FocusOnDirective,
    FileDropDirective,
    HighlightPipe,
    LoaderComponent,
    ButtonComponent,
    ApprovalPopupComponent,
    DaterangepickerComponent,
    MultiSelectFilterComponent,
  ],
  exports: [
    SanitizeHTmlPipe,
    OrderByPipe,
    InputWithCounterComponent,
    AutocompleteSearchComponent,
    DropdownMenuComponent,
    ClickOutsideDirective,
    FocusOnDirective,
    FileDropDirective,
    HighlightPipe,
    LoaderComponent,
    ButtonComponent,
    ApprovalPopupComponent,
    DaterangepickerComponent,
    MultiSelectFilterComponent,
  ],
  entryComponents: [InputWithCounterComponent, AutocompleteSearchComponent, ApprovalPopupComponent],
})

/** @desc Common module to handle shared services **/
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts